export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          手机吃瓜
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl font-heading text-foreground-950 mb-3">随时随地，精彩不错过</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                爆瓜网移动端适配完美，手机浏览器直接访问官网入口即可畅享全部内容。
                无论是在地铁上、午休时还是睡前刷一刷，最新吃瓜爆料一手掌握。
                添加到手机桌面，吃瓜更便捷。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <span className="px-4 py-2 rounded-full text-sm font-medium bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer">iOS 入口</span>
                <span className="px-4 py-2 rounded-full text-sm font-medium bg-accent-500 text-foreground-950 whitespace-nowrap cursor-pointer">Android 入口</span>
                <span className="px-4 py-2 rounded-full text-sm font-medium border border-foreground-300 text-foreground-700 whitespace-nowrap cursor-pointer">网页版直达</span>
              </div>
            </div>
            <div className="w-40 h-72 md:w-48 md:h-80 rounded-2xl overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20mobile%20app%20mockup%20with%20warm%20coral%20red%20theme%2C%20modern%20news%20feed%20UI%20design%2C%20clean%20minimal%20layout%2C%20editorial%20style%2C%20no%20text&width=480&height=800&seq=app-mockup&orientation=portrait" alt="爆瓜网手机版预览" className="w-full h-full object-cover object-top" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}